<template>
  <div class="reset">
      <div class="back">
          <div class="div-center">
              <div class="content">
                  <h3>Reset Password</h3>
                  <hr />
                  <form>
                      <div v-if="!token" class="form-group">
                          <label for="email">Email address</label>
                          <input type="email" class="form-control" id="email" v-model="email" placeholder="Email">
                      </div>                     
                      <div v-if="token" class="form-group">
                          <p>Your password should be at least 8 characters long.</p>
                          <!--<label for="password">New Password</label>-->
                          <input type="password" class="form-control" id="password" v-model="password" placeholder="New Password">
                      </div>                     
                      <div v-if="token" class="form-group">
                          <!--<label for="password2">Re-type New Password</label>-->
                          <br/>
                          <input type="password" class="form-control" id="password2" v-model="password2" placeholder="Re-type New Password">
                      </div>                     
                      <div class="info">{{infoMessage}}</div>
                      <br>
                      <button type="button" class="btn btn-primary" @click="reset">Reset</button>
                      <div class="error">{{errorMessage}}</div>
                      <hr/>
                      <router-link class="nav-link" to="login">Back to Login</router-link>
                  </form>
              </div>                   
          </div>
      </div> 
  </div>
</template>
<script>

export default {
  name: "Register",
  components: { 
  },
  props: {
  },
  data() {
    return {
        email: '',
        password: '',
        password2: '',
        token: null,
        errorMessage: '',
        infoMessage: ''  
    };
  },
  created: function() {
    this.email = localStorage.getItem('userEmail');
    localStorage.clear();  

    this.token = this.$route.query.code;
  },
  methods: {
      reset: function() {
        this.errorMessage = '';       
        if(this.token) {
            this.$http.post(this.apiUrl + 'users/resetpassword', { Token: this.token, Password: this.password, Password2: this.password2 })
                .then((response) => {
                    this.$router.push('login'); 
                }, 
                (error) => {
                    switch(error.response.status) {
                        default:
                            this.errorMessage = 'Error';
                    }
                });
        }
        else {
            this.$http.post(this.apiUrl + 'users/sendpasswordresetemail', { Email: this.email })
                .then((response) => {
                    this.infoMessage = 'Password reset email sent - please check your email.';
                }, 
                (error) => {
                    switch(error.response.status) {
                        case 404:
                            this.errorMessage = 'No user found with that email address';
                            break;
                        default:
                            this.errorMessage = 'Error';
                    }
                });
        }
      }
  }
};
</script>
<style scoped>
     th, td {
        text-align: left
    }

    .back {
        background: #e2e2e2;
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0
    }

    .div-center {
        width: 400px;
        height: 400px;
        background-color: #fff;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        max-width: 100%;
        max-height: 100%;
        overflow: auto;
        padding: 1em 2em;
        border-bottom: 2px solid #ccc;
        display: table;
    }

    div.content {
        display: table-cell;
        vertical-align: middle;
    }

    div.error {
        color: red;
        display: inline;
        padding-left: 15px;
    }       
    div.info {
        color: green;
        display: inline;
        padding-left: 15px;
    }
    a.nav-link {
        padding-left: 0px
    }
</style>
